export enum VisitBillStatus {
  AwaitingCharges,
  ChargesEntered,
  InReview,
  Ready,
  Paid,
  Archived,
}
